$(".review-slider").slick({
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay:5000,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1, // Ensure only 1 slide is shown
          slidesToScroll: 1, // Ensure only 1 slide is scrolled
        },
      },
    ],
  });
  $(".template-index .our_case_flex").slick({
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    autoplay:5000,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1, // Ensure only 1 slide is shown
          slidesToScroll: 1, // Ensure only 1 slide is scrolled
        },
      },
    ],
  });


  $('.e-marketing_flex').slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 10000,
    arrows: false,
    swipe: false,
    slidesToShow: 6,
    cssEase: 'linear',
    pauseOnFocus: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 2, // Ensure only 1 slide is shown
          slidesToScroll: 1, // Ensure only 1 slide is scrolled
        },
      }
    ],
  });




   document.addEventListener("DOMContentLoaded", function () {
     if (window.innerWidth <= 1026) {
$(".brand_flex").slick({
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    autoplay:5000,
    responsive: [
      {
        breakpoint: 1026,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2, // Ensure only 1 slide is shown
          slidesToScroll: 1, // Ensure only 1 slide is scrolled
        },
      },
    ],
  });
       
     }
   });